export const EDIT_DASHBOARD_ITEM_NAME = "edit_dashboard_item";
export const EDIT_DASHBOARD_ITEM_DESC = `Edits an existing dashboard item (title/description/linked feature) via GraphQL.

Use when the user wants to rename a dashboard card, adjust its description, or point the card to a different feature/view/job.

Input:
- 'id' (required): Dashboard item ID to update.
- 'name' (optional): New dashboard item name.
- 'description' (optional): New description. Omit to keep existing.
- 'featureId' (optional): New feature/view/job ID to bind to this card. Omit to keep existing.

Output:
- Returns the updated item basics (id, type, name, description, featureId) and navigation helpers 'dashboardPath'/'dashboardUrl'.

Notes:
- Provide at least one of 'name', 'description', or 'featureId'.
- Write operation; requires confirmation before execution.
- Feature IDs map to Index Worker jobs or Search/User Analytics views depending on the dashboard item type.`;
